import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import cx from 'helpers/cx'

import { AddWidgetIcon } from '@pleio/icons/add-widget'
import { CrossIcon } from '@pleio/icons/cross'

import Popover from 'js/components/Popover'

import styles from './AddWidgetButton.module.css'
import WidgetPicker from './WidgetPicker'

const AddWidgetButton = ({ id, onAdd, show, setShow, className, ...rest }) => {
    const { t } = useTranslation()

    const actionsRef = useRef(null)
    const buttonRef = useRef(null)

    const handleAddWidget = (type) => {
        actionsRef.current?.close()
        onAdd(type)
    }

    return (
        <div className={cx(styles.wrapper, className)} {...rest}>
            <Popover
                actionsRef={actionsRef}
                open={show}
                setOpen={setShow}
                content={<WidgetPicker onAddWidget={handleAddWidget} />}
                side="top"
                anchor={buttonRef}
            >
                <button
                    id={id}
                    className={styles.overlay}
                    data-testid="button-add-widget"
                >
                    <div className={styles.button} ref={buttonRef}>
                        {show ? <CrossIcon /> : <AddWidgetIcon />}
                        <span style={{ marginTop: '8px' }}>
                            {show
                                ? t('page.close-widgets')
                                : t('page.add-widget')}
                        </span>
                    </div>
                </button>
            </Popover>
        </div>
    )
}

export default AddWidgetButton
